import React from 'react';
import Chart from 'react-apexcharts';
import axios from '../../../axios';
import { useEffect, useState } from 'react';



export default function GrafikPenjualan({ chartColor = "#27CFA7" }) {
    
   

    const [series, setSeries] = useState([
    { name: "Sales", data: [] },
    // { name: "Orders", data: [] },
  ]);
  const [options, setOptions] = useState({
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: ["#3D7FF9", "#27CFA7"],
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 2,
      lineCap: "round",
    },
    markers: {
      size: 4,
      hover: { size: 7 },
    },
    xaxis: {
      categories: [],
      labels: {
        style: { fontSize: "14px" },
      },
    },
    yaxis: [
      {
        title: { text: "Penjualan (Rp)" },
        labels: {
          formatter: (value) => `Rp${value.toLocaleString("id-ID")}`,
          style: { fontSize: "14px" },
        },
      },
    //   {
    //     opposite: true,
    //     title: { text: "Order" },
    //     labels: {
    //       formatter: (value) => `${value}`,
    //       style: { fontSize: "14px" },
    //     },
    //   },
    ],
    tooltip: {
      y: {
        formatter: (value, { seriesIndex }) =>
          seriesIndex === 0
            ? `Rp${value.toLocaleString("id-ID")}`
            : `${value} orders`,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
    },
  });

    useEffect(() => {
    axios.get("/admin/sales-report/monthly").then((res) => {
      setSeries([
        {
          name: "Sales",
          data: res.data.sales,
        },
        // {
        //   name: "Orders",
        //   data: res.data.orders,
        // },
      ]);

      setOptions((prev) => ({
        ...prev,
        xaxis: {
          ...prev.xaxis,
          categories: res.data.months,
        },
      }));
    });
  }, []);

    return (
        <div class="card h-100">
            <div class="card-body">
                <div class="mb-20 flex-between flex-wrap gap-8">
                    <h4 class="mb-0">Grafik Penjualan</h4>
                </div>
                <Chart options={options} series={series} type="line" height={350} />
            </div>
        </div>
    );
}
